"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hexToString = function (hex) {
    return new Buffer(hex.substring(2), "hex").toString();
};
exports.default = hexToString;
